"use strict";
/**
 * Created by rouven on 24.02.17.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var Row = function (_a) {
    var children = _a.children, grid = _a.grid, rowData = _a.rowData, selection = _a.selection, trId = _a.trId, trClassName = _a.trClassName, props = __rest(_a, ["children", "grid", "rowData", "selection", "trId", "trClassName"]);
    var className = (0, classnames_1["default"])('grid-row', {
        'grid-row-selected': selection
            && rowData.hasOwnProperty('id')
            && selection.indexOf(rowData.id) !== -1
    }, trClassName);
    return (react_1["default"].createElement("tr", { className: className, id: trId }, react_1["default"].Children.map(children, function (child, colId) { return react_1["default"].cloneElement(child, __assign({ grid: grid, rowData: rowData, colId: colId, selection: selection }, props)); })));
};
exports["default"] = Row;
